import { getClient } from '@/lib/restClient';
import { MenuManagementBrandMenuService } from '@/services/BrandMenu/MenuManagementBrandMenuService';

export const useMenuManagementDeleteBrandMenu = async (
  id: string
): Promise<void> => {
  const menuManagementBrandMenuService = new MenuManagementBrandMenuService(
    getClient()
  );

  return menuManagementBrandMenuService.delete(id);
};
